import { Type } from '@angular/core'

export class IceCourseItem {
    constructor(
        public component: Type<any>,
        public data: any
    ){}
}